import React from 'react'

import { Grid, Input, SimpleCollapse } from 'components'
import { FONTS, SPACING } from 'utils'

import {
  TableBodyStyled,
  TableCellStyled,
  TableContainerStyled,
  TableHeadStyled,
  TableRowStyled,
  TableStyled,
  TableFooter,
  Button
} from 'components'
import { COLORS, FORMAT } from 'utils'
import { IFornecedor } from 'services/NGT/SupplierRegistration'
import { ResponseEfetivoMovimentacao } from 'services/NGT/AnalyzeCRE'
import { AlignHorizontalCenter, Label } from '@mui/icons-material'
import { alignProperty } from '@mui/material/styles/cssUtils'

export interface IEfetivosCadastrados {
  control: any
  errors: any
  tableInfos: ITableEfetivos
  setRowsPerPage: any
  tableData: ResponseEfetivoMovimentacao[]
}

export interface ITableEfetivos {
  page: number
  setPage: (page: number) => void
  rowsPerPage: number
  totalItems: number
}

const EfetivosCadastradosCollapse: React.FC<IEfetivosCadastrados> = ({
  control,
  errors,
  tableInfos,
  setRowsPerPage,
  tableData
}: IEfetivosCadastrados) => {
  const handleChangePage = (newPage: number) => {
    tableInfos.setPage(newPage)
  }

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setRowsPerPage(parseInt(event.target.value, 10))
    tableInfos.setPage(1)
  }
  return (
    <SimpleCollapse title="EFETIVOS CADASTRADOS NA MOVIMENTAÇÃO">
      {!tableData || tableData.length === 0 ? (
        <p
          style={{
            textAlign: 'center',
            fontWeight: 'bold',
            fontFamily: 'Roboto, Arial'
          }}
        >
          Não há registro de Efetivos Cadastrados na Movimentação
        </p>
      ) : (
        <TableContainerStyled>
          <TableStyled>
            <TableHeadStyled>
              <TableRowStyled>
                <TableCellStyled textColor="blueFonts" align="center">
                  Nacionalidade
                </TableCellStyled>
                <TableCellStyled textColor="blueFonts" align="center">
                  CPF/Passaporte
                </TableCellStyled>
                <TableCellStyled textColor="blueFonts" align="center">
                  Gênero
                </TableCellStyled>
                <TableCellStyled textColor="blueFonts" align="center">
                  Nome
                </TableCellStyled>
                <TableCellStyled textColor="blueFonts" align="center">
                  Status
                </TableCellStyled>
                <TableCellStyled textColor="blueFonts" align="center">
                  Data Admissão
                </TableCellStyled>
                <TableCellStyled textColor="blueFonts" align="center">
                  Data Demissão
                </TableCellStyled>
                <TableCellStyled textColor="blueFonts" align="center">
                  Tipo Efetivo
                </TableCellStyled>
                <TableCellStyled textColor="blueFonts" align="center">
                  Função
                </TableCellStyled>
                <TableCellStyled textColor="blueFonts" align="center">
                  Categoria
                </TableCellStyled>
                <TableCellStyled textColor="blueFonts" align="center">
                  Competência
                </TableCellStyled>
                <TableCellStyled textColor="blueFonts">
                  Compartilhados
                </TableCellStyled>
              </TableRowStyled>
            </TableHeadStyled>
            <TableBodyStyled>
              {tableData.length > 0 &&
                tableData
                  .filter((row => row.cdStatus.toUpperCase() == 'ATIVO'))
                  //.sort((a, b) => a.nmColaborador.localeCompare(b.nmColaborador))
                  .concat(
                    tableData
                      .filter((row => row.cdStatus.toUpperCase() == 'DEMITIDO'))
                      //.sort((a, b) => a.nmColaborador.localeCompare(b.nmColaborador))
                  )
                  .concat(
                    tableData
                      .filter((row => row.cdStatus.toUpperCase() != 'ATIVO' && row.cdStatus.toUpperCase() != 'DEMITIDO'))
                     // .sort((a, b) => a.nmColaborador.localeCompare(b.nmColaborador))
                  )
                  .map((row, index) => (
                    <TableRowStyled key={`${index}-${row.idMovEfetivo}`}>
                      <TableCellStyled align="center">
                        {row.cdNacionalidade?.trim().toUpperCase() || '------'}
                      </TableCellStyled>
                      <TableCellStyled align="center">
                        {FORMAT.documento(row.cdCpfPassaporte) || '------'}
                      </TableCellStyled>
                      <TableCellStyled align="center">
                        {row.cdGenero?.trim().toUpperCase() || '------'}
                      </TableCellStyled>
                      <TableCellStyled align="left">
                        {row.nmColaborador.trim().toUpperCase() || '------'}
                      </TableCellStyled>
                      <TableCellStyled align="center">
                        {row.cdStatus.toUpperCase() || '------'}
                      </TableCellStyled>
                      <TableCellStyled align="center">
                        {FORMAT.formatDDMMYYYY(row.dtAdmissao) || '------'}
                      </TableCellStyled>
                      <TableCellStyled align="center">
                        {FORMAT.formatDDMMYYYY(row.dtDemissao) || '------'}
                      </TableCellStyled>
                      <TableCellStyled align="center">
                        {row.cdTipoEfetivo || '------'}
                      </TableCellStyled>
                      <TableCellStyled align="center">
                        {row.txFuncao.toUpperCase() || '------'}
                      </TableCellStyled>
                      <TableCellStyled align="center">
                        {row.cdCategoria?.trim().toUpperCase() || '------'}
                      </TableCellStyled>
                      <TableCellStyled align="center">
                        {FORMAT.competencia(row.nuAnoMesCompetencia) || '------'}
                      </TableCellStyled>
                      <TableCellStyled align="center">
                        {row.numContrato || '------'}
                      </TableCellStyled>
                    </TableRowStyled>
                  ))}
            </TableBodyStyled>
          </TableStyled>
          {tableInfos && tableInfos.page !== undefined && (
            <TableFooter
              page={tableInfos.page}
              rows={tableData}
              disabled={false}
              totalItems={tableInfos.totalItems}
              rowsPerPage={tableInfos.rowsPerPage}
              handleChangePage={(teste) => handleChangePage(teste)}
              handleChangeRowsPerPage={(teste) => handleChangeRowsPerPage(teste)}
            />
          )}
        </TableContainerStyled>
      )}
    </SimpleCollapse>
  )
}

export default EfetivosCadastradosCollapse
